<template>
  <div class="player-props-component" :class="[{'empty': (playerProps && playerProps.length === 0 || filteredPlayerPropsEventMarkets.length === 0) && !isLoading}]">
    <v-expansion-panel v-if="!isPlayerPropsEmpty" class="player_props_holder" v-model="expansionPanel" :class="[{'withContent': filteredPlayerPropsEventMarkets.length > 0 && !isLoading}]">
      <v-expansion-panel-content :disabled="!isCarouselMode" :class="[{'feature-tab': isFeatureTabs}]">
        <template v-if="isCarouselMode" v-slot:header>
          <div class="pp_header">
            <div class="header-title">
              <span class="pp_icon"></span>
              <span class="pp_title">{{ $t('PlayerProps.Widget.Title') }}</span>
            </div>
          </div>
          <circle-loader v-if="isLoading && !isFeatureTabs" />
        </template>
        <v-card class="player-props-w" :class="{ 'one-player-props-only': filteredPlayerPropsEventMarkets.length === 1 }">
          <div v-for="event in filteredPlayerPropsEventMarkets" :key="event.idfoevent" class="props-wrapper" :class="[{ 'one-props-only': filteredPlayerPropsEventMarkets.length === 1 }]" :data-eid="event.idfoevent">
            <player-props-widget :event="event" :competitions="competitions" :oneEvent="filteredPlayerPropsEventMarkets.length === 1"></player-props-widget>
          </div>
          <p v-if="!isLoading && isPlayerPropsEmpty">{{ $t('PlayerProps.Widget.EmptyResponse') }}</p>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <div v-if="(playerProps && playerProps.length === 0 || filteredPlayerPropsEventMarkets.length === 0) && !isLoading" class="no-available-props">
      <p>{{ $t('PlayerProps.Widget.EmptyResponse') }}</p>
    </div>
  </div>
</template>


<script>
import config from '@/config'
import store from '@/store'
import BettingOffer from '@/components/mixins/BettingOffer'
import Screen from '@/components/mixins/Screen'
import Gtm from '@/components/mixins/Gtm'
import killswitch from '@/components/mixins/killswitch'
import CircleLoader from '@/components/common/CircleLoader'
import PlayerPropsWidget from './PlayerPropsWidget'
import lib from '@/library'
import teaserPriceType from '@/library/teaserPriceType'

export default {
  name: 'PlayerPropsWidgetComponent',
  components: { CircleLoader, PlayerPropsWidget },
  mixins: [
    BettingOffer,
    Gtm,
    Screen,
    killswitch
  ],
  props: [
    'displayMode',
    'eventId',
    'isHomePage',
    'competitions',
    'sportType',
    'isSportsPage',
    'isFeatureTabs',
    'isPanelExpanded'
  ],
  data () {
    return {
      updateInterval: null,
      isMounted: false,
      skipFirstExpand: false
    }
  },
  computed: {
    isCarouselMode () {
      return this.displayMode === 'carousel'
    },
    expansionPanel: {
      get () {
        return store.getters['playerPropsState/getExpansionPanel']
      },
      set (value) {
        store.commit('playerPropsState/setExpansionPanel', value)
      }
    },
    playerPropsPeriodicalUpdate () {
      return config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET && config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET.periodic_update_interval
    },
    playerProps () {
      return store.getters['playerPropsState/getPlayerProps']
    },
    uid () {
      return store.getters['getUid'] || localStorage.getItem('customer')
    },
    isLoading () {
      let storeModule = !this.isFeatureTabs ? 'playerPropsState' : 'featureTabsState'
      return store.getters[`${storeModule}/getIsLoading`]
    },
    isPlayerPropsEmpty () {
      return store.getters['playerPropsState/getIsPlayerPropsEmpty']
    },
    filteredPlayerPropsEventMarkets () {
      let events = this.playerProps.map(event => {
        let marketsToProcess = event.markets || []
        let markets = marketsToProcess.filter((market) => {
          let isTradable = market.istradable
          let csvpricetypes = this.ksMarketActivePriceTypes(market, event)
          const hasPrice = market.selections.every(sel => (sel.currentpriceup !== undefined && sel.currentpricedown !== undefined) && (sel.currentpriceup !== null && sel.currentpricedown !== null))
          let hasTeaserPriceType = csvpricetypes.some(pt => teaserPriceType.isTeaserPriceType(pt))
          return (isTradable && (market.selections && hasPrice && market.selections.length > 0) && !hasTeaserPriceType)
        })
        return { ...event, markets: markets }
      }).filter(event => event.markets.length > 0)
      lib.personalization.playerProps.subscribeToMarkets(events)

      return events
    },
    collapseOnInit () {
      return config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET && config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET.collapse_on_load ? config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET.collapse_on_load : 0
    },
    updateTriggers () {
      return JSON.stringify({
        a: this.isSportsPage,
        b: this.competitions,
        c: this.sportType
      })
    }
  },
  methods: {
    getPlayerProps (isPeriodical = false) {
      if (this.isFetchingPlayerProps) return

      let storeModule = !this.isFeatureTabs ? 'playerPropsState' : 'featureTabsState'
      if (!isPeriodical) store.commit(`${storeModule}/setIsLoading`, true)

      try {
        this.isFetchingPlayerProps = true
        if (this.isSportsPage && (!this.competitions || this.competitions.length === 0) && !this.sportType) {
          store.commit('playerPropsState/setPlayerProps', [])
          store.commit('featureTabsState/setIsLoading', false)
          store.commit('featureTabsState/setExpansionPanel', 0)
          this.stopPeriodicalUpdatePlayerProps()
          return false
        }
        lib.personalization.playerProps.fetchPlayerProps(this.uid, this.eventId, this.competitions, this.isHomePage, this.sportType, this.isSportsPage)
      } catch (error) {
        console.error('Error fetching Player Props:', error)
      } finally {
        this.isFetchingPlayerProps = false
      }
    },
    startPeriodicalUpdatePlayerProps () {
      if (!this.playerPropsPeriodicalUpdate) return false
      if (this.updateInterval) {
        return
      }
      this.updateInterval = setInterval(() => {
        if (!this.isFetchingPlayerProps) {
          this.getPlayerProps(true)
        }
      }, this.playerPropsPeriodicalUpdate)
    },

    stopPeriodicalUpdatePlayerProps () {
      if (this.updateInterval) {
        clearInterval(this.updateInterval)
        this.updateInterval = null
      }
    }
  },
  mounted () {
    this.isMounted = true
    this.skipFirstExpand = true
    let storeModule = !this.isFeatureTabs ? 'playerPropsState' : 'featureTabsState'
    store.commit(`${storeModule}/setExpansionPanel`, null)
  },
  beforeDestroy () {
    this.stopPeriodicalUpdatePlayerProps()
  },
  watch: {
    updateTriggers: {
      handler () {
        this.getPlayerProps()
        this.stopPeriodicalUpdatePlayerProps()
        this.startPeriodicalUpdatePlayerProps()
      },
      immediate: true
    },
    isPlayerPropsEmpty (newVal) {
      if (newVal) {
        store.commit('playerPropsState/setExpansionPanel', null)
      }
    },
    isSportsPage (newVal) {
      store.commit('playerPropsState/setPlayerProps', [])
    }
    // isPanelExpanded (newVal, oldVal) {
    //   if (!newVal && this.isMounted) this.stopPeriodicalUpdatePlayerProps()
    //   if (newVal && this.isMounted) {
    //     if (this.skipFirstExpand) {
    //       this.skipFirstExpand = false
    //       return
    //     }
    //     this.getPlayerProps()
    //     this.startPeriodicalUpdatePlayerProps()
    //   }
    // }
  }
}
</script>

<style scoped lang="stylus">
@import "~@/css/config"
.application
  .player-props-component
    background var(--player-props-widget-holder-bgr)
    &.empty
      .player-props-w
        padding-bottom 0
    .player_props_holder
      >>>.v-expansion-panel__header
        background  var(--player-props-widget-holder-bgr) !important
        .loader
          flex none
          margin 0 15px 0 0
.player_props_holder
  background var(--player-props-widget-holder-bgr)
  margin 0
  box-shadow none !important
  width auto
  //padding-bottom 10px
  @media mobile-big-and-below
    margin 0
  &.withContent
   margin-bottom 5px
   @media mobile-big-and-below
    margin 0
  >>>.v-expansion-panel__container--active.feature-tab
    .v-expansion-panel__header
      display none
    @media mobile-big-and-below
      border-bottom 0
  >>>.v-expansion-panel__container--active
    .v-expansion-panel__header
      margin-bottom 0 !important
      min-height 43px
  >>>.v-expansion-panel__header
    border none !important
    height 43px
    padding 12px 8px
    @media mobile-big-and-below
      padding-right 2px
    .pp_header
      display flex
      align-items center
      justify-content space-between
      .header-title
        display flex
        align-items center
        //padding-left 15px
        @media mobile-big-and-below
          padding-left 0
    .pp_icon
      background var(--player-props-widget-icon) 100% center no-repeat
      width 27px
      height 20px
      display inline-flex
      margin-right 10px
      @media mobile-big-and-below
        margin-right 5px
    .pp_title
      font-size 16px
      font-family 'Roboto Condensed Bold'
  >>>.v-expansion-panel__header__icon .v-icon
    color var(--player-props-widget-holder-openclose-icon-color) !important
  >>>.v-expansion-panel__body
    padding-left 5px
  .one-player-props-only
    justify-content center
  .player-props-w
    background var(--player-props-widget-holder-bgr)
    display flex
    overflow-x auto
    margin-left 0
    overflow-y hidden
    padding-bottom 10px
    z-index 5
    color var(--player-props-widget-holder-color)
    scroll-snap-type: x mandatory
    .one-props-only
      width 95%
      margin-right 5px
      @media mobile-big-and-below
        width 100%
    .props-container
      width 100%
    .props-wrapper
      scroll-snap-align: start
.no-available-props
  padding-bottom 10px
  padding-left 5px
  color var(--player-props-widget-holder-color)
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/playerPropsWidget/PlayerPropsWidgetComponent.vue